/* eslint-disable camelcase */
// import required from './required'
import password from './password'
import repeatChar from './repeatChar'
import distinct from './distinct'
import idcheck from './idcheck'

export default {
  // required,
  idcheck,
  distinct,
  password,
  repeatChar
}



// WEBPACK FOOTER //
// ./src/config/validate/rules/index.js